import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import useFunctions from "../ts/useFunctions";
import { Fragment } from "react/jsx-runtime";
import {
  ArrowBackIosNewRounded,
  Box,
  CustomIconButton,
} from "components/common";

export interface ReactImageGalleryItem {
  original: string;
  thumbnail?: string;
}

export default function ProductDetailMiddle() {
  const { loading, data, onBackClick } = useFunctions();

  const isVideo = (url: string) => url?.toLowerCase().includes(".mp4");

  const items: ReactImageGalleryItem[] = data.images.map((src: string) => {
    const isVid = isVideo(src);
    const posterFallback = data.images.find((img) => !isVideo(img));

    return {
      original: src,
      thumbnail: isVid && posterFallback ? posterFallback : src,
    };
  });

  const renderItem = (item: ReactImageGalleryItem) => {
    const isVid = isVideo(item.original);

    return isVid ? (
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <video
          src={item.original}
          controls
          autoPlay
          muted
          loop
          playsInline
          style={{ width: "100%", maxHeight: "500px", objectFit: "cover" }}
        />
      </div>
    ) : (
      <img
        src={item.original}
        alt="Product"
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
    );
  };

  return loading ? null : (
    <Fragment>
      <Box display={{ xs: "block", md: "none" }} marginBottom={2}>
        <CustomIconButton color="primary" onClick={onBackClick}>
          <ArrowBackIosNewRounded />
        </CustomIconButton>
      </Box>
      <ImageGallery
        lazyLoad={false}
        items={items}
        renderItem={renderItem}
        infinite={false}
        thumbnailPosition="left"
        showPlayButton={false}
        showThumbnails={true}
        showFullscreenButton={false}
        showBullets={false}
        showNav={false}
      />
    </Fragment>
  );
}
